<app-message-maintenance-form [messageMaintenance]="messageMaintenance" [onClose]="onClose"
    [refreshList]="refreshList" />